import React from 'react';
import SelectFilter from '../SelectFilter/SelectFilter';
import { TIP_CALCULATION_OPTIONS } from './constants';
import styles from './TipCalculationRow.module.scss';

export interface TipCalculationRowProps {
  /** The current boolean value (true = Before, false = After) */
  value: boolean;
  /** Callback when the selection changes */
  onChange: (value: boolean) => void;
  /** Label text to display next to the dropdown */
  label: string;
  /** Loading state */
  loading?: boolean;
  /** Additional CSS classes */
  className?: string;
  /** Placeholder text for the dropdown */
  placeholder?: string;
}



const TipCalculationRow: React.FC<TipCalculationRowProps> = ({
  value,
  onChange,
  label,
  loading = false,
  className = '',
  placeholder = 'Before/After',
}) => {
  const selectedOption = TIP_CALCULATION_OPTIONS.find(option => option.value === value) || null;

  const handleChange = (option: typeof TIP_CALCULATION_OPTIONS[0] | null) => {
    if (option !== null) {
      onChange(option.value);
    }
  };

  return (
    <div className={`${styles.tipCalculationRow} ${className}`}>
      <div className={styles.controlWidth}>
        <SelectFilter
          options={TIP_CALCULATION_OPTIONS}
          value={selectedOption}
          onChange={handleChange}
          placeholder={placeholder}
          loading={loading}
        />
      </div>
      <span className={styles.calculationLabel}>{label}</span>
    </div>
  );
};

export default TipCalculationRow;
